import { useState } from "react";

import "react-loading-skeleton/dist/skeleton.css";

import useWindowDimensions from "../../hooks/useWindowDimentions";

import WallOfFameSkeleton from "./WallOfFameCard/Skeleton";
import WallOfFameCard from "./WallOfFameCard";

import useSWR from "swr";

import { FetchWallOfFame } from "../../lib/FetchWallOfFame";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { NextArrow, PrevArrow } from "../ui/Arrows";

const WallOfFame = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const items: Record<number, number> = {
    1920: 4,
    1200: 3,
    850: 3,
    720: 3,
    650: 2,
    480: 1,
  };
  const { range } = useWindowDimensions();
  const [itemsPerPage] = useState(items[range]);

  const { data: students, isLoading } = useSWR(
    currentPage
      ? `/wp-json/wall-of-fame/v1/weekly-wall?page=${currentPage}&per_page=${itemsPerPage}`
      : "",
    () => FetchWallOfFame(currentPage, itemsPerPage)
  );

  const users = students?.data || [];
  const total = students?.total || 0;

  const carouselRresponsive = {
    1920: {
      breakpoint: { max: 1920, min: 1201 },
      items: 4,
    },
    720_1200: {
      breakpoint: { max: 1200, min: 651 },
      items: 3,
    },
    650: {
      breakpoint: { max: 650, min: 481 },
      items: 2,
    },
    480: {
      breakpoint: { max: 480, min: 0 },
      items: 1,
    },
  };

  if (isLoading) {
    return (
      <div className="w-full px-8">
        <div className="w-full relative">
          <Carousel
            arrows={false}
            removeArrowOnDeviceType={["1920", "720_1200", "650", "480"]}
            responsive={carouselRresponsive}
            className="carosuel-wrapper"
          >
            {Array.from({ length: 6 }).map((_, index) => (
              <WallOfFameSkeleton key={index} />
            ))}
          </Carousel>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full px-8">
      <div className="w-full relative">
        <Carousel
          responsive={carouselRresponsive}
          className="carosuel-wrapper [&_button.react-multiple-carousel__arrow--right]:!hidden [&_button.react-multiple-carousel__arrow--left]:!hidden "
        >
          {users &&
            users.map((user, idx) => <WallOfFameCard {...user} key={idx} />)}
        </Carousel>

        <div className="carousel-button absolute w-full top-1/2 -translate-y-1/2 left-0">
          <div className="flex w-full justify-between">
            <div className="left-arrow">
              <PrevArrow
                onClick={() =>
                  setCurrentPage((currentPage) =>
                    currentPage === 1
                      ? Math.ceil(total / itemsPerPage)
                      : currentPage - 1
                  )
                }
              />
            </div>
            <div className="right-arrow relative">
              <NextArrow
                onClick={() => {
                  setCurrentPage((currentPage) =>
                    Math.ceil(total / itemsPerPage) > currentPage
                      ? currentPage + 1
                      : 1
                  );
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WallOfFame;
